export const state = () => ({
  products: [],
  client: null,
  cartOpen: false,
  country: null,
  buybutton: null
})

export const getters = {
  getProduct: (state) => (sku) => {
    return state.products.find(product => product.variants[0].sku === sku)
  },
  getBuyButton: (state) => (buybuttons) => {
    return buybuttons.find(buybutton => buybutton.country === state.country)
  },
}

export const mutations = {
  setProducts(state, products) {
    state.products = products
  },
  setClient(state, client) {
    state.client = client
  },
  setCartOpen(state, value) {
    state.cartOpen = value
  },
  setCountry(state, data) {
    state.country = data
  },
  setBuyButton(state, data) {
    state.buybutton = data
  },
}

export const actions = {
  buildClient({ commit, dispatch, state }) {
    if (window && window.ShopifyBuy) {

      const countryCode = state.buybutton.countrycode || 'DK';
      const language = state.buybutton.language || 'da';
      const countryLanguage = language+'-'+countryCode;
      const client = window.ShopifyBuy.buildClient({
        domain: 'checkout-dk.copenhagendistillery.com',
        storefrontAccessToken: '6ad779b4fcbd7121cfac5470a2dddce8',
        language: countryLanguage,
      });

      client.graphQLClient.internationalizationDirective = "@inContext(country: "+countryCode+", language: "+language.toUpperCase()+")"

      client.shop.fetchLocalization().then(function (res) {
          return res;
      });

      const localStorageCheckoutKey = `${client.config.storefrontAccessToken}.${client.config.domain}.checkoutId`;
      let checkout = null;
      // if (localStorage.getItem(localStorageCheckoutKey)) {
      //     const checkoutId = localStorage.getItem(localStorageCheckoutKey);
      //   checkout = client.checkout.fetch(checkoutId).then((checkout) => {
      //     checkout.customAttributes = null
      //     if (window.ui) {
      //       Object.keys(window.ui.components).forEach((type) => {
      //         window.ui.components[type].forEach((component) => {
      //           component.destroy()
      //         })
      //         window.ui.components[type] = []
      //       })
      //     }
      //     window.ui = window.ShopifyBuy.UI.init(client)
      //     commit('setClient', client)
      //     dispatch('fetchProducts')

      //     localStorage.setItem(localStorageCheckoutKey, checkout.id)
      //   })
          
      // }

      const input = {
          buyerIdentity: {
            countryCode: state.buybutton.countrycode || 'DK'
        }
      };

      if (!checkout){
        checkout = client.checkout.create(input).then((checkout) => {
          checkout.customAttributes = null
            if (window.ui) {
            Object.keys(window.ui.components).forEach((type) => {
              window.ui.components[type].forEach((component) => {
                component.destroy()
              });
              window.ui.components[type] = [];
            });
          }
          window.ui = window.ShopifyBuy.UI.init(client)
          commit('setClient', client)
          dispatch('fetchProducts')

          localStorage.setItem(localStorageCheckoutKey, checkout.id);
        });
      }
    }
  },
  // buildClient({ commit, dispatch, state }) {
  //   if (window && window.ShopifyBuy) {
  //     const client = window.ShopifyBuy.buildClient({ domain: state.buybutton.domain, storefrontAccessToken: state.buybutton.token })
  //     if (window.ui) {
  //       Object.keys(window.ui.components).forEach((type) => {
  //         window.ui.components[type].forEach((component) => {
  //           component.destroy()
  //         });
  //         window.ui.components[type] = [];
  //       });
  //     } 
  //     const input = {
  //         buyerIdentity: {
  //           countryCode: 'DE',
  //         },
  //     };

  //     const localStorageCheckoutKey = `${client.config.storefrontAccessToken}.${client.config.domain}.checkoutId`;

  //     client.checkout.create(input).then((checkout) => {
  //         localStorage.setItem(localStorageCheckoutKey, checkout.id)
          
  //         const ui = window.ShopifyBuy.UI.init(client)
  //         window.ui = ui // keep ui outside Vuex
  //         commit('setClient', client)
  //         dispatch('fetchProducts')
  //     });

  //   }
  // },
  async fetchProducts({ commit, state }) {
    await state.client.product.fetchAll(50).then((products) => {
      commit('setProducts', products)
    });
  },
}